<div class="dialog-container">
  <div class="dialog-header">
    <h2>{{data.fazenda}}</h2>
    <button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="info-container">
      <div class="info-item">
        <strong>Área Total:</strong> {{data.area_total}} ha
      </div>
      <div class="info-item">
        <strong>Último arquivo inserido:</strong> {{data.ultimoShape}}
      </div>
    </div>

    <div class="map-wrapper">
      <div class="map-container" id="map-dialog"></div>
      <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Carregando mapa...</p>
      </div>
    </div>
  </mat-dialog-content>
</div>